<template v-if="Object.keys(errors).length > 0">
  <div class="box">
    <h4 class="header">{{$t('errorTitle')}}</h4>
    <ul class="list">
      <li class="list-item" v-for="message in errors">
        {{message}}
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  props: {
    errors: Object,
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {
  },
  methods: {},
}
</script>

<style scoped>
  .box {
    padding: 10px;
    margin: 35px 0;
    text-shadow: 0 1px 0 rgba(255, 255, 255, 0.5);
    background-color: #F2DEDE;
    border: 1px solid #EED3D7;
    border-radius: 4px;
    color: #B94A48;
  }
  .list {
    padding: 0 20px;
    margin: 5px 0 0 0;
    list-style: disc;
  }
</style>